import { createReducer, on } from '@ngrx/store';

import * as PermissionActions from './permission.actions';
import { initialState } from './permission.state';

export const permissionReducer = createReducer(
  initialState,
  on(PermissionActions.loadUserMenus, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PermissionActions.loadUserMenusSuccess, (state, { menus }) => ({
    ...state,
    userMenus: menus,
    loading: false,
  })),
  on(PermissionActions.loadUserMenusFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);
